export type SecondFactorEnrollmentStartedPayload = {
	readonly secretBase32: string;
	readonly otpauthUri: string;
};

export type SecondFactorEnrollmentStartedAction = {
	type: 'SECOND_FACTOR_ENROLLMENT_STARTED';
	payload: SecondFactorEnrollmentStartedPayload;
};

export default (payload: SecondFactorEnrollmentStartedPayload): SecondFactorEnrollmentStartedAction => ({
	type: 'SECOND_FACTOR_ENROLLMENT_STARTED',
	payload,
});
